export interface TokenParams {
  bespokeId?: string
  country: string
  language: string
  trackerParameters: any
  paymentMethodId?: number
  isThreshold: boolean
  adPaymentMethods?: number[]
  tierId?: number
  tierHash?: string
  purchaseAmount?: number
  adServerUrl: string
  locale: string
  matchZeroInterest?: boolean
  theme?: string
  customPaymentMethodIds?: string[]
  legacyOSMClientId?: string // is received as query param in interstitial link via web-sdk
  interstitialTriggerer?: string
}

export default function createToken(params: TokenParams, macros: string[]) {
  return window.btoa(JSON.stringify({
    tierId: params.tierId,
    tierHash: params.tierHash,
    macros,
    language: params.language,
    country: params.country,
    purchaseAmount: params.purchaseAmount,
    paymentMethodId: params.paymentMethodId ? Number(params.paymentMethodId) : params.paymentMethodId,
    clientId: params.legacyOSMClientId,
    customPaymentMethodIds: params.customPaymentMethodIds,
    isThreshold: params.isThreshold
  }))
}